import React, { Component } from "react";
import _ from "lodash";
import { Table } from "semantic-ui-react";
import getPersonName from "../common/Name";
import { getDate } from "../common/DisplayDate";
import getBusinessName from "../common/Business";
import Address from "./Address";

class ProfessionalLicenseRecordDetail extends Component {
  componentDidMount() {}

  render() {
    const results = [];
    const { node } = this.props;
    if (node !== undefined && node !== null) {
      const nameNode = _.get(node, "name[0]");
      const additionalOrigName = _.get(
        node,
        "additionalOrigName[0].full[0]._",
        ""
      );
      const companyName = _.get(node, "companyName[0]._", "");
      results.push(
        <Table.Row key={`ProfLicense_Record_Name_Row_${this.props.index}`}>
          <Table.Cell>Name:</Table.Cell>
          <Table.Cell>
            {nameNode
              ? getPersonName(
                  _.get(nameNode, "first[0]._", ""),
                  "",
                  _.get(nameNode, "last[0]._", ""),
                  this.props
                )
              : _.get(node, "originalName[0].full[0]._", "")}
            {additionalOrigName !== "" && (
              <span>
                <br />
                {additionalOrigName}
              </span>
            )}
            {companyName !== "" && (
              <span>
                <br />
                {getBusinessName(companyName, this.props)}
              </span>
            )}
          </Table.Cell>
          <Table.Cell>License Type:</Table.Cell>
          <Table.Cell>{_.get(node, "licenseType[0]._", "")}</Table.Cell>
        </Table.Row>
      );
      const standardizedAddresses = [];
      const standardizedAddressNodes = _.get(
        node,
        "standardizedAddress[0].address"
      );
      if (standardizedAddressNodes !== undefined) {
        _.forEach(
          standardizedAddressNodes,
          (standardizedAddressNode, stdAddIndex) => {
            standardizedAddresses.push(
              <span
                key={`Item_Filing_Address_${this.props.index}_${stdAddIndex}`}
              >
                <Address
                  addressNode={standardizedAddressNode}
                  {...this.props}
                />
                <br />
              </span>
            );
          }
        );
      }

      results.push(
        <Table.Row key={`ProfLicense_Record_Address_Row_${this.props.index}`}>
          <Table.Cell>Address:</Table.Cell>
          <Table.Cell>{standardizedAddresses}</Table.Cell>
          <Table.Cell>Source State:</Table.Cell>
          <Table.Cell>{_.get(node, "sourceState[0]._", "")}</Table.Cell>
        </Table.Row>
      );
      results.push(
        <Table.Row
          key={`ProfLicense_Record_Orig_Address_Row_${this.props.index}`}
        >
          <Table.Cell>Original Address:</Table.Cell>
          <Table.Cell>
            <Address
              addressNode={_.get(node, "originalAddress[0]")}
              {...this.props}
            />
          </Table.Cell>
          <Table.Cell>Profession/Board:</Table.Cell>
          <Table.Cell>{_.get(node, "professionOrBoard[0]._", "")}</Table.Cell>
        </Table.Row>
      );
      results.push(
        <Table.Row key={`ProfLicense_Record_Ssn_Row_${this.props.index}`}>
          <Table.Cell>SSN:</Table.Cell>
          <Table.Cell>{_.get(node, "SSN[0]._", "")}</Table.Cell>
          <Table.Cell>Expiration Date:</Table.Cell>
          <Table.Cell>{getDate(_.get(node, "expirationDate[0]"))}</Table.Cell>
        </Table.Row>
      );

      results.push(
        <Table.Row key={`ProfLicense_Record_Status_Row_${this.props.index}`}>
          <Table.Cell>Status:</Table.Cell>
          <Table.Cell>{_.get(node, "status[0]._", "")}</Table.Cell>
          <Table.Cell>License Number:</Table.Cell>
          <Table.Cell>{_.get(node, "licenseNumber[0]._", "")}</Table.Cell>
        </Table.Row>
      );
      results.push(
        <Table.Row key={`ProfLicense_Record_Date_Seen_Row_${this.props.index}`}>
          <Table.Cell>Date Last Seen:</Table.Cell>
          <Table.Cell>{getDate(_.get(node, "dateLastSeen[0]"))}</Table.Cell>
          <Table.Cell>Issue Date:</Table.Cell>
          <Table.Cell>{getDate(_.get(node, "issuedDate[0]"))}</Table.Cell>
        </Table.Row>
      );
    }

    return (
      <Table>
        <Table.Body>{results}</Table.Body>
      </Table>
    );
  }
}

export default ProfessionalLicenseRecordDetail;



// WEBPACK FOOTER //
// ./src/components/searchresults/ProfessionalLicenseRecordDetail.js